import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://sso.dev.chainsmart.id',
  realm: 'btn',
  clientId: 'smartshield-app-dev',
});

export default keycloak;
